/* eslint-disable no-underscore-dangle */
import { Box, Button, Paper } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState, useCallback } from "react";
import { DeleteOutlineOutlined, CheckOutlined } from "@mui/icons-material";
import { WrapperContent } from "../../components/WrapperContent";
import { PageHeader } from "../../components/PageHeader";
import { Loader } from "../../components/Loader";
import AdsTable from "./table";
import { getAdsToApprove } from "../../api/ads";
import { PropertyActionDialog, TPropertyActionStatus } from "./action-dialog";

export default function ManageAds() {
  const [rowsSelected, setRowsSelected] = useState<
    readonly { code: number; id: string }[]
  >([]);
  const [showActionsDialog, setShowActionsDialog] = useState<boolean>(false);
  const [dialogStatus, setDialogStatus] =
    useState<TPropertyActionStatus | null>(null);
  const [refreshCount, setRefreshCount] = useState<number>(0);

  const { isFetching, data: rows = [] } = useQuery({
    queryKey: ["ads_approval", refreshCount],
    queryFn: getAdsToApprove,
    refetchOnWindowFocus: false,
  });

  const updateRefreshCount = useCallback(
    () => setRefreshCount((prevState) => prevState + 1),
    [],
  );

  const onChangeRowsSelected = useCallback(
    (n: { code: number; id: string }[]) => {
      setRowsSelected(n);
    },
    [],
  );

  return (
    <WrapperContent>
      <PageHeader title="Moderación de anúncios">
        <div className="inline-flex gap-5">
          <Button
            variant="contained"
            color="error"
            size="medium"
            onClick={() => {
              setDialogStatus("PAUSED_BY_APPLICATION");
              setShowActionsDialog(true);
            }}
            disabled={rowsSelected.length === 0}
          >
            <DeleteOutlineOutlined fontSize="small" />
            <span className="inline-flex ml-1.5">Rechazar seleccionados</span>
          </Button>

          <Button
            variant="contained"
            color="success"
            size="medium"
            onClick={() => {
              setDialogStatus("ACTIVE");
              setShowActionsDialog(true);
            }}
            disabled={rowsSelected.length === 0}
          >
            <CheckOutlined fontSize="small" />
            <span className="inline-flex ml-1.5">Aprobar seleccionados</span>
          </Button>
        </div>
      </PageHeader>

      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2, p: 1.5 }}>
          {isFetching ? (
            <div className="flex justify-center">
              <Loader inline />
            </div>
          ) : (
            <AdsTable
              rows={rows}
              rowsSelected={rowsSelected}
              onChangeRowsSelected={onChangeRowsSelected}
              updateRefreshCount={updateRefreshCount}
            />
          )}
        </Paper>
      </Box>

      {dialogStatus && rowsSelected.length > 0 && showActionsDialog && (
        <PropertyActionDialog
          rowsSelected={rowsSelected}
          newStatus={dialogStatus}
          onClose={() => setShowActionsDialog(false)}
          onSuccess={() => {
            setShowActionsDialog(false);
            setRowsSelected([]);
            updateRefreshCount();
          }}
        />
      )}
    </WrapperContent>
  );
}
